import { signInAnonymously, onAuthStateChanged, User } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from './firebase';


export class Auth {
  static instance: Auth;
  user: User | undefined;
  userId = '-1';

  constructor() {
    signInAnonymously(auth)
    .then(() => {
      console.log('signInAnonymously')
    })
    .catch((error) => {
      console.error(error)
    });

    onAuthStateChanged(auth, (newUser) => {
      console.log('newUser', newUser);
      if (newUser) {
        this.user = newUser;
        this.userId = newUser?.uid;
      }
    });
  }

  static getInstance() {
    if (!Auth.instance) {
      Auth.instance = new Auth();
    }
    return Auth.instance;
  }
}

export const getUserId = () => Auth.getInstance().userId;
export const getUser = () => Auth.getInstance().user;

export const useAuth = () => {
  const [user, setUser] = useState<User | null>();
  useEffect(() => {
    const unlisten = onAuthStateChanged(auth, (newUser) => {
      setUser(newUser);
    });
    return () => {
      unlisten();
    }
  }, [])
  return user;
}